import { SortDirection, SortInfo } from '@stylehaven/components';
import { DottedKey, MetadataField } from '../../record/entities/metadata-field.entity';

/**
 * The deadline sort, in the two key families the Taken pages send it in. They are different field names to
 * the engine, so a page has to use the one it has always sent — swapping them changes the sort's meaning
 * silently. The two evaluate pages send the flat one; depot-management sends the dotted one.
 */
export const taskDueDateAscSortInfo: SortInfo = {
    field: MetadataField.TasksTaskDueDate,
    direction: SortDirection.ASC
};

export const taskDueDateAscDottedSortInfo: SortInfo = {
    field: DottedKey.TasksTaskDueDate,
    direction: SortDirection.ASC
};
